import React from 'react';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import LanguageIcon from '@mui/icons-material/Language';
import SectionWrapper from '../shared/SectionWrapper';

const AboutSection: React.FC = () => (
  <SectionWrapper id="about" dark>
    <Grid container spacing={8} alignItems="center">
      <Grid size={{ xs: 12, md: 5 }}>
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Box
            sx={{
              width: { xs: 200, md: 260 },
              height: { xs: 200, md: 260 },
              borderRadius: '50%',
              bgcolor: '#141414',
              border: '1px solid rgba(255, 255, 255, 0.06)',
              mx: { xs: 'auto', md: 0 },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                fontFamily: '"Bricolage Grotesque", sans-serif',
                fontSize: { xs: '3.5rem', md: '4.5rem' },
                fontWeight: 800,
                color: '#ffffff',
              }}
            >
              KS
            </Typography>
          </Box>
        </motion.div>
      </Grid>

      <Grid size={{ xs: 12, md: 7 }}>
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography variant="h2" sx={{ mb: 3, color: '#ffffff' }}>
            About
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2, lineHeight: 1.8 }}>
            ZerveMe is led by <Box component="span" sx={{ color: '#ffffff', fontWeight: 600 }}>Kevin Singh</Box>, a
            Senior Data / AI Engineer with 10+ years of experience designing and optimizing
            data solutions across traditional and modern architectures.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2, lineHeight: 1.8 }}>
            With expertise spanning cloud data warehouses (AWS, Azure, GCP), ETL/ELT
            development, Databricks, Snowflake, and AI-powered analytics, Kevin has
            delivered production solutions for 20+ enterprise clients including
            Kimberly-Clark, Beam Suntory, Coty, and General Mills.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
            Beyond data engineering, Kevin builds full-stack applications and AWS cloud
            infrastructure, deploying production SaaS apps on serverless architectures
            using Terraform, GitHub Actions CI/CD, and modern web frameworks.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {[
              { icon: LinkedInIcon, href: 'https://www.linkedin.com/in/kevin-singh-908547b4' },
              { icon: GitHubIcon, href: 'https://github.com/kevinsinghdeveloper' },
              { icon: LanguageIcon, href: 'https://thekevinsingh.com' },
            ].map(({ icon: Icon, href }) => (
              <IconButton
                key={href}
                component="a"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  color: 'text.secondary',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  '&:hover': { color: '#ffffff', borderColor: 'rgba(255, 255, 255, 0.2)' },
                  transition: 'all 0.2s ease',
                }}
              >
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Box>
        </motion.div>
      </Grid>
    </Grid>
  </SectionWrapper>
);

export default AboutSection;
